import { useScreenSize } from '@/hooks/useScreenSize';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
};

export const BellIcon = (props: Props) => {
    const { color = 'white', width = '36', height = '36', ...rest } = props;
        const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M21 28H15" stroke={color} strokeWidth="1.6" />
            <path d="M28 24H8" stroke={color} strokeWidth="1.6" />
            <path d="M11 24V16C11 12.134 14.134 9 18 9V9C21.866 9 25 12.134 25 16V24" stroke={color} strokeWidth="1.6" />
        </svg>
    );
};
